$('#flavors').owlCarousel({
    loop:false,
    margin:30,
    nav:false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:3
        },
        1000:{
            items:4
        }
    }
})
$('#collection').owlCarousel({
    loop:false,
    margin:30,
    nav:false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:3
        },
        1000:{
            items:4
        }
    }
})
$(window).scroll(function(){
    if ($(this).scrollTop() > 100) {
        $('#dynamic').addClass('newClass');
    } else {
        $('#dynamic').removeClass('newClass');
    }
});

$(document).ready(function(){
  $('#owl-logo-slider').owlCarousel({
    loop: false,
    margin: 30,         // Spacing between logos
    nav: false,         // Usually hidden for logos
    dots: false,        // Keeps it clean
    autoplay: false,     // Makes logos slide automatically
    autoplayTimeout: 3000,
    responsive: {
      0: {
        items: 2  ,loop: true,     // Mobile
      },
      768: {
        items: 3 ,loop: true,        // iPad/Tablet
      },
      1000: {
        items: 6       // Desktop
      }
    }
  });
});




	